import { render, staticRenderFns } from "./VacationExpandItem.vue?vue&type=template&id=ca39546e"
import script from "./VacationExpandItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./VacationExpandItem.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports